import { render, staticRenderFns } from "./ParentList.vue?vue&type=template&id=adc743e0&"
import script from "./ParentList.vue?vue&type=script&lang=js&"
export * from "./ParentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports